import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon, FilterIcon } from "@icarius-icons";
import Form from "./form";
import { deleteAdvanceSettingsAction } from "../../actions";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import FilterDialog from "../filterDialog";

const Item = (props) => {
    const [filterDialogIsOpen, setFilterDialogIsOpen] = useState(false);

    const { data, types, employeesList, closeCreate } = props;

    const dispatch = useDispatch();
    const isPeru = useIsSocietyCountry("PE");
    const color = useSelector(getAppColor);
    const isCreate = !Boolean(data);

    const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

    const handleDelete = () => {
        if (isCreate) {
            closeCreate();
        } else {
            dispatch(deleteAdvanceSettingsAction(data));
        }
    };

    const handleClose = () => {
        Boolean(data) && setIsOpen((prev) => !prev);
    };

    const getTypeName = () => {
        return types.filter((type) => type.key === data.type)[0].value;
    };

    const handleOpenDeleteDialog = () => {
        dispatch(
            openDialogAction({
                title: getLocalizedString("advanceDeleteDialogTitle"),
                msg: getLocalizedString("confirmDeleteAdvance"),
                onConfirm: handleDelete,
            })
        );
    };

    const getHasFilters = () => {
        return data?.sqlFilter;
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 10,
                    background: isOpen || isCreate ? color : "",
                    color: (isOpen || isCreate) && "white",
                }}
            >
                <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                    <Grid
                        container
                        item
                        xs={11}
                        style={{ cursor: Boolean(data) ? "pointer" : "" }}
                        onClick={handleClose}
                    >
                        {isCreate ? (
                            <DataContainer
                                lg={12}
                                sm={12}
                                md={12}
                                text={getLocalizedString(
                                    isPeru ? "advanceOrAdvancedPaymentCreation" : "advanceCreation"
                                )}
                            />
                        ) : (
                            <>
                                <DataContainer sm={12} lg={2} md={2} text={data.code} />
                                <DataContainer sm={12} lg={5} md={5} text={data.name} />
                                <DataContainer sm={12} lg={5} md={5} text={getTypeName()} />
                            </>
                        )}
                    </Grid>

                    <Grid container direction="row" item xs={1} justify="center">
                        {!isCreate && (
                            <Tooltip title={getLocalizedString("filter")}>
                                <IconButton size={"small"} disableRipple onClick={() => setFilterDialogIsOpen(true)}>
                                    <FilterIcon
                                        style={{ fill: getHasFilters() ? color : "var(--mainText)", height: "15px" }}
                                        fontSize="small"
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title={getLocalizedString("delete")}>
                            <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>
            {isOpen && (
                <Form
                    data={data}
                    types={types}
                    employeesList={employeesList}
                    handleClose={isCreate ? closeCreate : handleClose}
                />
            )}
            {filterDialogIsOpen && (
                <FilterDialog open={filterDialogIsOpen} data={data} handleClose={() => setFilterDialogIsOpen(false)} />
            )}
        </>
    );
};

export default Item;
